// extracted by mini-css-extract-plugin
module.exports = {"root":"Consent_root__2m2w9","content":"Consent_content__ja_7T","footer":"Consent_footer__2RSIw"};